// apiClient.js only ever caches NON-SENSITIVE profile display data (email, tenant name,
// tier, account type — never the session token, which lives in an HttpOnly cookie) in
// localStorage, so each origin can synchronously decide what to render before making its
// first API call. That cache doesn't survive the www.scribe11.com → app.scribe11.com
// handoff on its own: localStorage is scoped per-origin, and these are two different
// origins by design, even though the underlying session (a cross-origin cookie sent via
// credentials:'include' on every apiClient.js request) is equally valid on both.
//
// This carries that same non-sensitive data across the ONE redirect that needs it — the
// moment a sign-in on the marketing domain hands off into the app domain — via a query
// param, then strips it from the URL immediately on arrival so it never lingers in browser
// history any longer than that single redirect.
const HANDOFF_PARAM = '_p'

export function appendProfileHandoff(path, profile, isEnterprise) {
  const url = new URL(path, 'http://placeholder.invalid') // path may be a bare "/app/systems" with no origin
  url.searchParams.set(HANDOFF_PARAM, encodeURIComponent(JSON.stringify({ profile, isEnterprise })))
  return url.pathname + url.search
}

// Called once, early, from the router guard. If a handoff payload is present in the
// current navigation's query, saves it to THIS origin's own localStorage (via the two
// setters passed in, to avoid this module importing apiClient.js and creating a cycle)
// and returns the clean path with the param stripped. Returns null if there's nothing to
// consume, so the caller can tell "handled" apart from "nothing to do here."
export function consumeProfileHandoff(query, fullPath, saveFreeProfile, saveEnterpriseProfile) {
  const raw = query[HANDOFF_PARAM]
  if (!raw) return null
  let payload
  try {
    payload = JSON.parse(decodeURIComponent(raw))
  } catch {
    payload = null // malformed — ignore; the destination view's own auth-gate handles "not signed in" already
  }
  if (payload?.profile?.email) {
    if (payload.isEnterprise) saveEnterpriseProfile(payload.profile)
    else saveFreeProfile(payload.profile)
  }
  const url = new URL(fullPath, 'http://placeholder.invalid')
  url.searchParams.delete(HANDOFF_PARAM)
  return url.pathname + url.search
}
